export default __webpack_public_path__ + "static/media/markerOrange.21b28941.svg";